import styled from 'styled-components';
import RichText from '../rich-text';

export const Container = styled.section``;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Title = styled(RichText)`
  margin-bottom: 0;
  font-size: 1rem;
`;
